import React from 'react';
import { Box, FormControl, FormControlLabel, FormLabel, InputLabel, Radio, RadioGroup, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        main: {
            ".MuiFormControlLabel-root": {
                marginRight: "16px",
            },
            ".MuiRadio-root": {
                color: "#c4c4c4",
            },
            ".MuiRadio-root.Mui-checked": {
                color: theme.palette.primary.main,
            },
            ".MuiFormLabel-root": {
                fontSize: "14px",
                color: "#222222",
                marginBottom: "4px",
                fontWeight: 500,
                whiteSpace: "nowrap",
            },
            ".MuiFormControlLabel-label": {
                fontSize: "14px",
                color: "#7d7d7d",
            },
        },
    };
});

const CommonRadioButton = ({
    text,
    name,
    options,
    value,
    onChange,
    fontWeight,
    labelSize,
    labelColor,
    valid,
    className,
    whiteSpace
}) => {
    const { classes } = useStyles();
    const theme = useTheme()
    return (
        <Box className={classes.main}>
            {text && (
                <Box display="flex" fontSize="12px" flexDirection={"row"}>
                    <InputLabel
                        sx={{
                            letterSpacing: "0.03em",
                            marginRight: "2px",
                            fontWeight: fontWeight,
                            fontSize: labelSize || "14px",
                            color: labelColor || "#222222",
                            whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            marginBottom: "0px"
                        }}
                    >
                        {text}
                    </InputLabel>
                    {valid && (
                        <Typography color="#EF627A" component={"caption"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}
            <FormControl component="fieldset" className={className}>
                <RadioGroup
                    row
                    name={name}
                    value={value}
                    onChange={onChange}
                    sx={{ ".MuiRadio-root": { color: theme.palette.primary.main, padding: "5px" }, marginLeft: "6px", }}
                >
                    {options.map((option, index) => (
                        <FormControlLabel
                            key={index}
                            value={option.value}
                            control={<Radio color='primary' />}
                            label={option.label}
                            sx={{ color: theme.palette.primary.main, }}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Box>
    );
};

export default CommonRadioButton;
